// Module
var code = "<span> <input type=\"file\" name=\"file\" id=\"file\" class=\"inputfile\"/> <label for=\"file\" ng-transclude></label> </span>";
// Exports
module.exports = code;